import { DependencyList, useCallback } from 'react';

type AnyFunction = (...args: any[]) => any;

const useCallbackOnce = <T extends AnyFunction>(
  callback: T,
  deps: DependencyList,
) => {
  return useCallback(once<T>(callback), deps);
};

export default useCallbackOnce;

const once = <T extends AnyFunction>(fn: T) => {
  let alreadyRan = false;
  return (...args: Parameters<T>): ReturnType<T> | void => {
    if (!alreadyRan) {
      alreadyRan = true;
      return fn(...args);
    }
  };
};
